import { configureStore } from '@reduxjs/toolkit'
import  generalSlice  from './features/general/generalSlice';
import registerSlice from './register/registerSlice';
import productSlice from './product/productSlice';
import  searchSlice  from './search/searchSlice';
import popupSlice from './popup/popupSlice';

export const store = configureStore({
  reducer: {general : generalSlice,register: registerSlice, product:productSlice ,search:searchSlice, popup:popupSlice},
})